/**
 * Global 域类型（权威定义）。
 *
 * @canonical 5.3-2.2.4
 * @归属 global 域（入口路径、前端 date-event store）
 * @对外入口 `import { EntryDashboardPath, TDatalabDateEvent, ... } from '@dbl/core/global'`
 * @来源 合并自 `types/global.d.ts` 与既有本文件定义。
 *
 * 赛季事件 wire 类型见 `@dbl/services/global` · `IDateEventDto`。
 *
 * @see doc/refactor/docs/type-canonicalization-ledger.md
 */

// ==================== 赛季事件 store / 入口路径 ====================

/** 日期筛选器 Event 快捷项（`transformDateEventFormat` 输出 · 写入 `DATALAB_DATE_EVENT`）。 */
export interface IDateEventUiItem {
  start_date: string;
  end_date: string;
  event_type_id: number;
  event_type_name_cn: string;
  event_type_name_en: string;
  name: string;
  nameCN: string;
  sort: number;
  onClick: () => unknown;
}

/** 调用处理逻辑时的 Dashboard 入口路径（存量 enum，不改动）。 */
export enum EntryDashboardPath {
  DatalabLayout = 'datalab_layout',
  CommonDashboard = 'datalab_common_dashboard',
}

/** 全局变量 `DATALAB_DATE_EVENT` 的存储结构。 */
export type TDatalabDateEvent = {
  gameCode: string;
  data: Record<'hour' | 'date' | 'week' | 'month', IDateEventUiItem[]> | null;
  loading: boolean;
  error?: string | Error;
  pathType: EntryDashboardPath;
};
